export const success = '1000'
export const noRecordFound = '4953'
export const duplicateMail = '4954'
export const serverErr = '9650'
export const inactiveUser = '4960'
export const urlExpired = '4963'
export const emailOrPasswordWrong = '4964'
export const noChange = '4966'
export const registeredEmail = '4955'
export const notRegisteredEmail = '4968'
export const emailNotActivate = '4970'
export const amazonUpdateFail = '4969'
export const amazonInfoNotFound = '4972'
export const reachProductLimit = '4973'
export const exceptCountry = '4974'
export const amazonThrottleError = '4958'
export const maintenance = '4990'



// WEBPACK FOOTER //
// ./src/common/code.js